import {useEffect,useRef} from 'react';

/** Decorative only: no pointer interception or React updates while moving. */
export function NewTaskDotBackground(){
 const ref=useRef<HTMLCanvasElement>(null);
 useEffect(()=>{
  const canvas=ref.current,host=canvas?.parentElement;
  if(!canvas||!host)return;
  const context=canvas.getContext('2d');if(!context)return;
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
  let frame=0,width=0,height=0,x=0,y=0,started=0;
  const clear=()=>{cancelAnimationFrame(frame);frame=0;context.clearRect(0,0,width,height);};
  const resize=()=>{const rect=host.getBoundingClientRect();width=rect.width;height=rect.height;const ratio=Math.min(window.devicePixelRatio||1,2);canvas.width=Math.round(width*ratio);canvas.height=Math.round(height*ratio);context.setTransform(ratio,0,0,ratio,0,0);};
  const draw=(now:number)=>{
   context.clearRect(0,0,width,height);
   const age=(now-started)/750;if(age>=1||reduced.matches){frame=0;return;}
   const radius=20+age*130;
   for(let dx=Math.max(12,Math.floor((x-180)/24)*24+12);dx<Math.min(width,x+180);dx+=24){
    for(let dy=Math.max(12,Math.floor((y-180)/24)*24+12);dy<Math.min(height,y+180);dy+=24){
     const distance=Math.hypot(dx-x,dy-y),pulse=Math.max(0,1-Math.abs(distance-radius)/36)*(1-age);
     if(pulse<=0)continue;
     context.beginPath();context.arc(dx,dy,1+1.5*pulse,0,Math.PI*2);context.fillStyle=`rgba(139,109,132,${.5*pulse})`;context.fill();
    }
   }
   frame=requestAnimationFrame(draw);
  };
  const move=(event:PointerEvent)=>{if(reduced.matches||event.pointerType==='touch')return;const rect=host.getBoundingClientRect();x=event.clientX-rect.left;y=event.clientY-rect.top;if(!frame||performance.now()-started>140)started=performance.now();if(!frame)frame=requestAnimationFrame(draw);};
  const observer=new ResizeObserver(resize);observer.observe(host);resize();
  host.addEventListener('pointermove',move,{passive:true});host.addEventListener('pointerleave',clear);reduced.addEventListener('change',clear);
  return()=>{clear();observer.disconnect();host.removeEventListener('pointermove',move);host.removeEventListener('pointerleave',clear);reduced.removeEventListener('change',clear);};
 },[]);
 return <canvas ref={ref} aria-hidden="true" data-testid="new-task-dot-background" className="pointer-events-none absolute inset-0 h-full w-full" style={{backgroundImage:'radial-gradient(circle, #d9d5cf 1px, transparent 1px)',backgroundSize:'24px 24px',backgroundPosition:'0 0'}}/>;
}
